import { Meta } from 'components/Meta';
import { PageV2 } from 'types/schema';

type PageMetaProps = Pick<PageV2, 'pageTopSection' | 'seo' | 'content'>;

export const PageMeta = ({ data, noIndex }: { data: PageMetaProps; noIndex?: boolean }) => {
  return (
    <Meta
      title={data?.seo?.title || data?.pageTopSection?.title}
      description={data?.seo?.description || data?.pageTopSection?.subTitle}
      keywords={data?.seo?.keywords}
      noIndex={noIndex}
    />
  );
};
